import { startOfDay, endOfDay } from "date-fns"
import { Timestamp } from "gen/google/protobuf/timestamp_pb"
import { TimestampRange as TimestampRangePB } from "gen/proto/timestamprange/models_pb"
import { UUID } from "shared-ts/classes/uuid"
import { TimestampRange as TimestampRange } from "shared-ts/libs/dates/timestampRange"
import { WebUrl } from "shared-web/lib/webUrl"

import { GENERAL_LEDGER } from "features/pos/analytics/Reports/configuration/GeneralLedger"
import {
  defaultStagedParams,
  stagedKey,
  LOCATION_PARAM,
  ACCOUNT_PARAM,
  DATE_RANGE_PARAM,
  DEPARTMENT_PARAM,
  METHOD_PARAM,
  joinParameters,
  gatedStagedParam,
} from "features/pos/analytics/Reports/params"
import { deprecatedBuildQueryParams } from "lib/params"

export function generalLedger(
  accountId: UUID,
  locationId: UUID,
  date: Date,
  departmentIds: UUID[],
  methodIds: UUID[]
): WebUrl {
  return {
    pathname: "/admin/reporting/general-ledger",
    query: deprecatedBuildQueryParams({
      ...defaultStagedParams(GENERAL_LEDGER.config),
      [stagedKey(LOCATION_PARAM)]: locationId.toString(),
      [stagedKey(ACCOUNT_PARAM)]: accountId.toString(),
      [stagedKey(DATE_RANGE_PARAM)]: TimestampRange.toQueryParam(
        TimestampRangePB.create({
          start: Timestamp.fromDate(startOfDay(date)),
          end: Timestamp.fromDate(endOfDay(date)),
        })
      ),
      ...gatedStagedParam(
        DEPARTMENT_PARAM,
        joinParameters(departmentIds.map((id) => id.toString())),
        departmentIds.length > 0
      ),
      ...gatedStagedParam(
        METHOD_PARAM,
        joinParameters(methodIds.map((id) => id.toString())),
        methodIds.length > 0
      ),
    }),
  }
}
